import Component from 'vue-class-component';
import Vue from 'vue';
import { copy, showConfirmDialog } from '@/utils/util';
import RewritingLevelPopup from './components/rewritingLevelPopup.vue';
import moduleStore from '../textToVideo/store/textToVideo';

@Component({
  components: {
    RewritingLevelPopup,
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class smartTextPage extends Vue {

  text = ''; // 原文内容
  uniqueId = '';  // 文本id
  generateTimer = null;
  activeNames = ['1', '2']; // 展开的面板列表
  // tab列表
  tabList = [
    {
      id: 'title',
      type: 1,
      name: '智能标题',
      status: 'loading', // loading, success, empty
      activeGenerateId: 0, // 选中生成列表项的id
      generateList: [], // 生成列表
      checked: true, // 表示必须选中
    },
    {
      id: 'desc',
      type: 2,
      name: '智能描述',
      activeGenerateId: '',
      generateList: [],
      checked: true,
    },
    {
      id: 'citation',
      type: 3,
      name: '黄金开场',
      emptyName: '开场内容',
      tip: '✨使用后将会把黄金开场的吸睛内容，放置全文的开头',
      checkTip: '如果你的文案中已经含有黄金开场内容，请不要开启此选项避免开场重复赘述，黄金开场适合没有吸睛开头内容的文案辅助提升作品质量。',
      activeGenerateId: '',
      generateList: [],
    },
    {
      id: 'rewrite',
      type: 4,
      name: '智能改写',
      emptyName: '改写内容',
      nameContent: '改文',
      btnText: '开始改写',
      btnTexts: {
        'empty': '开始改写',
        'success': '重新改写',
        'loading': '改写中',
      },
      checkTip: '开启文案改写后会对文章内容进行调整，如果你的文案已经是爆款文案可以不开启此选项，避免爆款内容被改写掉。',
      activeGenerateId: '',
      generateList: [{
        id: 3,
        generate: false, //是否生成过改写，false说明未生成，需要显示空
      }],
      showOriginContent: true,  // 显示原文，使用折叠面板
    },
  ];
  activeTabId = this.tabList[0].id;
  get activeTab() {
    const tab = this.tabList.find(item => item.id === this.activeTabId);
    if (!tab.generateList || !tab.generateList.length) {
      tab.status = 'empty';
    } else {
      const isGeneratedLength = tab.generateList.filter(item => !item.text).length;
      tab.status = isGeneratedLength ? 'loading' : 'success';
      if (tab.showOriginContent && !tab.generateList[0].generate) {
        tab.status = 'empty';
      }
    }
    tab.btnText = tab.btnTexts && tab.btnTexts[tab.status] || '';
    return tab;
  }
  changeTab(item) {
    this.activeTabId = item.id;
    this.changeShowRestSymbol()
  }

  mounted() {
    const query = this.$route.query;
    // 选中的tab项
    const tabId = query.tabId as string;
    this.activeTabId = tabId || this.tabList[0].id;
    // 根据id获取列表
    this.uniqueId = query.uniqueId as string;
    this.getGenerateList();
    // 选中的id
    for (let index = 0; index < this.tabList.length; index++) {
      const item = this.tabList[index];
      item.activeGenerateId = +(query[item.id + 'Id'] as string) || '';
    }
    this.setSelectedIds();
  }

  // 智能文案页面会把选中id传回作品创建页
  setSelectedIds() {
    // 选中的id
    const selectedIds = {}
    for (let index = 0; index < this.tabList.length; index++) {
      const item = this.tabList[index];
      selectedIds[item.id] = item.activeGenerateId;
    }
    localStorage.setItem('smartTextSelectedIds', JSON.stringify(selectedIds));
  }

  // 选中使用
  doChecked(item, tab) {
    if (tab.activeGenerateId === item.id) { // 取消勾选
      if (tab.checked) { // 必须选中的，只有1条记录时不能取消勾选
        return;
      }
      this.setActiveGenerateId(tab, '');
      return;
    }
    // 之前没开启过，需要提示
    if (tab.checkTip && !tab.activeGenerateId) {
      return showConfirmDialog({
        title: '温馨提示',
        message: tab.checkTip,
        confirmButtonText: '开启',
        cancelButtonText: '不开启',
        closeOnClickOverlay: true,
      }).then(() => {
        this.setActiveGenerateId(tab, item.id);
      }).catch(() => { })
    }
    this.setActiveGenerateId(tab, item.id);
  }

  setActiveGenerateId(tab, id) {
    tab.activeGenerateId = id;
    this.setSelectedIds();
  }
  // 复制
  doCopy(text) {
    copy(text).then(() => {
      this.$toast('已成功复制');
    });
  }

  // 删除
  async doDel(task, tab) {
    const index = tab.generateList.findIndex(v => v.id === task.id);
    const nameStr = tab.nameContent || `${tab.name}${tab.generateList.length - index}`;
    const confirm = await showConfirmDialog({
      title: '提示',
      message: `你确定要删除「${nameStr}」吗？`,
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      closeOnClickOverlay: true,
    }).then(() => { return true; })
      .catch(() => { return false; });
    if (!confirm) return;

    const res = await this.$http('deleteSmartText', { recordId: task.id });
    if (res.code === 200) {
      this.$toast('删除成功');
      if (tab.showOriginContent) {
        tab.generateList = [{
          id: '',
          generate: false,
          text: ''
        }]
      } else {
        tab.generateList.splice(index, 1);
      }
      // this.getGenerateList();
    }
  }

  // 显示休止符
  showRestSymbol = false;
  changeShowRestSymbol() {
    this.showRestSymbol = false;
    this.$nextTick(() => {
      const element: any = this.$refs['content_' + this.activeTab.id]?.[0];
      if (element && element.scrollHeight > element.clientHeight) {
        this.showRestSymbol = true;
      }
    })
  }

  // 改写程度
  isLevelPopupVisible = false;
  showLevelPopup() {
    this.isLevelPopupVisible = true;
  }
  closeLevelPopup() {
    this.isLevelPopupVisible = false;
  }
  level = {};
  changeLevel(level) {
    this.level = level;
    this.isLevelPopupVisible = false;
  }

  /*********************************** 生成相关 *******************************/
  // 首次生成
  doFirstGenerate(tab) {
    this.doGenerate(tab);
  }
  // 生成
  async doGenerate(item) {
    if (!this.uniqueId) return;
    if (!this.text) return;
    const tab = this.tabList.find(v => v.id === item.id);
    if (!tab.generateList) tab.generateList = [];
    let checkNewTask = false; // 是否需要选中新任务
    if (tab.showOriginContent && tab.generateList[0] && tab.generateList[0].text) {
      const confirm = await showConfirmDialog({
        title: '提示',
        message: `重新改写会删除当前改写，是否继续`,
        confirmButtonText: '继续',
        cancelButtonText: '取消',
        closeOnClickOverlay: true,
      }).then(() => { return true; })
        .catch(() => { return false; });
      if (!confirm) return;
      if (tab.activeGenerateId === tab.generateList[0].id) checkNewTask = true;
      this.$http('deleteSmartText', { recordId: tab.generateList[0].id });
    }
    const params = {
      uniqueId: this.uniqueId,
      type: (item.id).toLocaleUpperCase(),
      inputParam: {
        [item.id + 'VO']: { content: this.text }
      }
    }
    tab.status = 'loading';
    const res = await this.$http('generateSmartText', params);
    if (res.code === 200 && res.data && res.data.id) {
      const newTask = {
        id: res.data.id,
        generate: true,
        text: ''
      };
      if (checkNewTask) this.setActiveGenerateId(tab, newTask.id);
      if (tab.showOriginContent) {
        tab.generateList = [newTask];
      } else {
        tab.generateList.unshift(newTask);
      }
      this.getGenerateList();
    }
  }
  // 获取所有生成结果，从作品创建页跳转过来使用
  async getGenerateList() {
    clearTimeout(this.generateTimer);
    if (!this.uniqueId) return;
    const res = await this.$http('getSmartTextList', {
      uniqueId: this.uniqueId,
      page: 1,
      size: 999
    });
    if (res.code === 200 && res.data) {
      const list = res.data.results || [];
      if (!list.length) return;
      let checkedItemId = '';
      for (let index = 0; index < this.tabList.length; index++) {
        const item = this.tabList[index];
        const generateList = list.filter(v => v.type === item.type && v.status !== 3).map(v => {
          return {
            id: v.id,
            status: v.status, //1 :生成中 2 :生成成功 3 :生成失败
            text: v.output && v.output.content || '',
          }
        });
        if (generateList.length > 0) {
          if (item.showOriginContent) {
            item.generateList = [{
              ...generateList[0],
              generate: true
            }];
          } else {
            item.generateList = generateList;
          }
          const checkedItem = generateList.find(v => v.id == item.activeGenerateId);
          checkedItemId = checkedItem && checkedItem.id;
        }
      }
      if (!checkedItemId) checkedItemId = list[0].id;
      this.getGenerateInput(checkedItemId);
      const isloadingTaskLength = list.filter(v => v.status === 1).length;
      if (isloadingTaskLength) {
        this.generateTimer = setTimeout(() => {
          this.getGenerateList();
        }, 5000);
      }
    } else {
      console.log(res);
    }
  }

  isLoadingText = false;
  // 获取原文案
  async getGenerateInput(id) {
    if (this.text || this.isLoadingText || !id) return;
    this.isLoadingText = true;
    const res = await this.$http('getSmartTextDetailbyIds', { recordIds: [id] });
    if (res.code === 200 && res.data && res.data.length) {
      const { input, type } = res.data[0];
      const name = this.tabList.find(v => v.type === type).id + 'VO';
      this.text = input && input[name] && input[name].content || '';
    }
    this.isLoadingText = false;
  }

}